
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateBlog } from "../../redux/actions/action";
import TextField from "../../components/formcomponents/TextField";

const EditBlog = ({ blog, onClose }) => {
  const [formData, setFormData] = useState({
    id: blog?.id,
    bloggerName: blog?.bloggerName || "",
    topicName: blog?.topicName || "",
    rolename: blog?.rolename || "",
    description: blog?.description || "",
    date: blog?.date ? new Date(blog.date).toISOString().split("T")[0] : "", // Correct date format
  });

  const [bloggerNameError, setBloggerNameError] = useState('');
  const [topicError, setTopicError] = useState('');
  const [roleError, setRoleError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [dateError, setDateError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setFormData({
      id: blog?.id,
      bloggerName: blog?.bloggerName || "",
      topicName: blog?.topicName || "",
      rolename: blog?.rolename || "",
      description: blog?.description || "",
      date: blog?.date ? new Date(blog.date).toISOString().split("T")[0] : "",
    });
  }, [blog]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validation checks
    if (name === "bloggerName") {
      setBloggerNameError("");
      validateBloggerName(value);
    } else if (name === "topicName") {
      setTopicError("");
      validateTopic(value);
    } else if (name === "rolename") {
      setRoleError("");
      validateRole(value);
    } else if (name === "description") {
      setDescriptionError("");
      validateDescription(value);
    } else if (name === "date") {
      setDateError("");
    }
  };

  const validateBloggerName = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('Blogger Name Must Contain Only Alphabets');
      return 'Blogger Name Must Contain Only Alphabets';
    }
  };

  const validateTopic = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('Topic Should Contain Only Alphabets');
      return 'Topic Should Contain Only Alphabets';
    } else {
      setErrorMessage('');
    }
  };

  const validateRole = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('Role Should Contain Only Alphabets');
      return 'Role Should Contain Only Alphabets';
    } else {
      setErrorMessage('');
    }
  };

  const validateDescription = (name) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!regex.test(name)) {
      setErrorMessage('Description Should Contain Only Alphabets');
      return 'Description Should Contain Only Alphabets';
    } else {
      setErrorMessage('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formattedData = {
      ...formData,
      date: formData.date ? new Date(formData.date).toISOString().split("T")[0] : null, // Ensure correct date format
    };

    // Dispatch the formatted data
    dispatch(updateBlog(formattedData));

    // Close the modal
    onClose();
  };

  return (
    <div className="relative bg-color w-screen-full md:ml-[-500px] lg:ml-[300px] mr-16  rounded-3xl border-4 border-white popup-content grid justify-items-start">
      <div className="bg-color p-8 rounded-lg shadow-lg border-4 border-white border-solid">

      <div className="bg-color text-white  p-10 pr-10 rounded-lg max-w-lg">
        <h2 className="text-lg font-semibold mb-4">Edit Blog</h2>
        <form onSubmit={handleSubmit}>

          <label className="mb-2 block">
            Blogger Name:
            <input
              type="text"
              name="bloggerName"
              value={formData.bloggerName}
              onChange={handleInputChange}
              className="block w-[247px] border border-gray-300 rounded-md px-1 py-2 text-sm"
            />
          </label>
          <label className="mb-2 block">
            Topic Name:
            <input
              type="text"
              name="topicName"
              value={formData.topicName}
              onChange={handleInputChange}
              className="block w-[247px] border border-gray-300 rounded-md px-1 py-2 text-sm"
            />
          </label>
          <label className="mb-2 block">
            Role Name:
            <input
              type="text"
              name="rolename"
              value={formData.rolename}
              onChange={handleInputChange}
              className="block w-[247px] border border-gray-300 rounded-md px-1 py-2 text-sm"
            />
          </label>
          <label className="mb-2 block">
            Description:
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="block w-[247px] border border-gray-300 rounded-md px-1 py-2 text-sm"
            />
          </label>
          <label className="mb-2 block">
            Date:
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              className="block w-[247px] border border-gray-300 rounded-md px-1 py-2 text-sm"
            />
          </label>

          <div className="flex justify-center mt-6 mb-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-black text-white py-2 px-6 rounded-lg mr-4"
            >
              Cancel
            </button>
            <button type="submit" className="bg-black text-white py-2 px-6 rounded-lg">
              Save
            </button>
          </div>
         
        </form>
      </div>
    </div>
    </div>
   
    
  );
};

export default EditBlog;





